import { createSlice } from "@reduxjs/toolkit";
import {
  getCommonQuizTopicThunk,
  createCommonQuizTopicThunk,
  updateCommonQuizTopicThunk,
  deleteCommonQuizTopicThunk,
} from "./StudentAssessmentQuiz.Thunk";
import StudentAssessmentSlice from "../StudentAssessment/StudentAssessment.Slice";

const initialState = {
  data: [],
  topic: [],
  loading: false,
  status: "",
  message: "",
  type: "",
  language: "",
  topicId: "",
  topicName: "",
  validityType: "",
  validity: "",
  usertype: "",
  disable_content_button: true,
};

const StudentAssessmentQuizSlice = createSlice({
  name: "studentAssessmentQuiz",
  initialState,
  reducers: {
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.topicId = "";
      state.topicName = "";
      state.disable_content_button = true;
    },
  },
  extraReducers: {
    [getCommonQuizTopicThunk.pending]: (state, action) => {
      state.topic = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getCommonQuizTopicThunk.fulfilled]: (state, action) => {
      state.topic = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getCommonQuizTopicThunk.rejected]: (state, action) => {
      state.topic = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [createCommonQuizTopicThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createCommonQuizTopicThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createCommonQuizTopicThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateCommonQuizTopicThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateCommonQuizTopicThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateCommonQuizTopicThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { usertype_change } = StudentAssessmentQuizSlice.actions;

export default StudentAssessmentQuizSlice.reducer;
